// Finance.js
import { Outlet, useLocation } from "react-router-dom";
import "./Finance.css";

const Finance = () => {
  const location = useLocation();
  // Derive tab title from path
  const getTitle = () => {
    const path = location.pathname.split("/").pop();
    const map = {
      revenue: "Revenue Overview",
      "store-payouts": "Store Payouts",
      "driver-payouts": "Driver Payouts",
      transactions: "Transactions",
      tax: "Tax Documents",
    };
    return map[path] || "Finance";
  };

  return (
    <div className="finance-container">
      <div className="data_head">
        <h1 className="data_heading">{getTitle()}</h1>
        {/* Optional: global date filters for revenue and transactions */}
      </div>
      <div className="finance-content">
        <Outlet /> {/* Child routes will render here */}
      </div>
    </div>
  );
};

export default Finance;
